<script setup lang="ts">
import { useI18n } from 'vue-i18n'

const { t } = useI18n({ useScope: 'global' })
</script>
<template>
  <div class="px-10 pb-10 pt-10 h-full flex flex-col space-y-6">
    <h1 class="typography-heading-1">{{ t('navigation.variables') }}</h1>
    <div class="flex-1 min-h-0">
      <ListVariables />
    </div>
  </div>
</template>
